// CommonJS so the UMD plugins' require('jquery') gets jQuery itself, not an ES module namespace
module.exports = window.jQuery;
